import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import classnames from "classnames"
import { ConnectForm, TextArea } from "lib/core/components/forms"
import "./PathGroupForm.css"

let fieldsData = {
  name: {
    placeholder: "Enter a lesson title",
    preventEnter: true,
    hideStatus: true,
    autoFocus: true,
    minimal: true,
    inline: true
  },
  description: {
    placeholder: "Add a 1-2 sentence of what they'll learn... (optional)",
    preventEnter: true,
    optional: true,
    minimal: true,
    inline: true
  }
}

let PathGroupForm = function (props) {
  let actionLabel, expanded, handleSubmit, isValid, onCancel
  ;({ fieldsData, handleSubmit, actionLabel, expanded, onCancel, isValid } =
    props)

  return (
    <form
      className={classnames("PathGroupForm", {
        "PathGroupForm--expanded": expanded
      })}
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          return handleSubmit()
        }
      }}
      onSubmit={handleSubmit}
      autoComplete="off"
    >
      <TextArea
        {...Object.assign(
          {
            className: "PathGroupForm__name Lesson__name"
          },
          fieldsData.name
        )}
      />
      <TextArea
        {...Object.assign(
          { className: "PathGroupForm__desc" },
          fieldsData.description
        )}
      />
      <div className="PathGroupForm__controls">
        <Button onClick={onCancel} styleType="blank">{`\
Cancel\
`}</Button>
        <SubmitButton
          {...Object.assign({}, props, {
            styleType: "primary",
            type: "submit"
          })}
        >
          {actionLabel}
        </SubmitButton>
      </div>
    </form>
  )
}

PathGroupForm = ConnectForm(PathGroupForm, fieldsData)
PathGroupForm.displayName = "PathGroupForm"

export default PathGroupForm
